import { useState, useEffect, useCallback } from 'react'
import type { IHeaderParams } from 'ag-grid-community'

export function SelectAllHeader(p: IHeaderParams) {
  const [checked, setChecked] = useState(false)

  const sync = useCallback(() => {
    const total = p.api.getDisplayedRowCount()
    const selected = p.api.getSelectedRows().length
    setChecked(total > 0 && selected === total)
  }, [p.api])

  useEffect(() => {
    p.api.addEventListener('selectionChanged', sync)
    return () => {
      // Grid мог быть уничтожен до того, как React-эффект снимется —
      // removeEventListener на destroyed API кидал AG Grid warning #26.
      if (!p.api.isDestroyed()) p.api.removeEventListener('selectionChanged', sync)
    }
  }, [p.api, sync])

  return (
    <div className="flex items-center justify-center w-full h-full">
      <input
        type="checkbox"
        checked={checked}
        onChange={() => {
          if (checked) p.api.deselectAll()
          else p.api.selectAll()
        }}
        className="cursor-pointer"
      />
    </div>
  )
}
